import React from "react";
import { Button } from 'react-bootstrap';
import { QUOTE_QUESTIONS } from "../AppConstants";
import Utilities from "../classes/Utilities";
import { IViolationList, IIncidentInfo, IDriver, ViolationSource } from "../classes/Domain";
import IncidentInfo from "../components/IncidentInfo";
import moment from "moment";

interface IState {
    driver: IDriver,
    propsMerged: boolean;
}

interface IProps {
    updatingStore?: boolean,
    violationList: IViolationList,
    driver: IDriver,
    driverIndex: number,
    errors: any,
    onDriverChange(driver: IDriver, index: number): void;
}

class VialationPart extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.onIncidentChange = this.onIncidentChange.bind(this);
        this.onIncidentDelete = this.onIncidentDelete.bind(this);

        this.state = {
            driver: this.props.driver,
            propsMerged: false
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.propsMerged) return prevState;
        const driver = nextProps.driver;

        if (driver) {
            const nextState = {
                ...prevState,
                driver: driver,
                propsMerged: true
            };

            return nextState;
        }

        return prevState;
    }

    onAccidentsViolationsChange(value: string) {
        let _driver = { ...this.state.driver, accidentsViolations: value };

        if (value === QUOTE_QUESTIONS.YES_NO.YES) {
            if (!this.state.driver.incidents || this.state.driver.incidents.length === 0) {
                let incendent: IIncidentInfo = {
                    category: "",
                    violation: "",
                    violationCode: "",
                    violationDate: moment(new Date()).toDate(),
                    convictionDate: null,
                    incidentDescription: "",
                    source: ViolationSource.ClientOrSystem
                };

                _driver.incidents = new Array<IIncidentInfo>();
                _driver.incidents.push(incendent);
            }
        }
        else {
            if (this.state.driver.incidents && this.state.driver.incidents.length > 0) {
                _driver.incidents = new Array<IIncidentInfo>();
            }
        }

        this.setState({ ...this.state, driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentChange(incident: IIncidentInfo, index: number) {
        let _driver = this.state.driver;
        _driver.incidents[index] = incident;

        this.setState({ ...this.state, driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentDelete(index: number) {
        let _driver = this.state.driver;
        _driver.incidents.splice(index, 1);

        if (_driver.incidents.length === 0) {
            _driver.accidentsViolations = QUOTE_QUESTIONS.YES_NO.NO;
        }

        this.setState({ ...this.state, driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    onIncidentAdd() {
        let _driver = this.state.driver;
        let incendent: IIncidentInfo = {
            category: "",
            violation: "",
            violationCode: "",
            violationDate: new Date(),
            convictionDate: null,
            incidentDescription: "",
            source: ViolationSource.ClientOrSystem
        };

        _driver.incidents.push(incendent);

        this.setState({ ...this.state, driver: _driver }, () => {
            this.props.onDriverChange(_driver, this.props.driverIndex);
        });
    }

    render() {
        return (
            <div>
                {
                    this.state.driver.incidents.map((incident, index) => (
                        <IncidentInfo
                            key={Utilities.uniqueId()}
                            updatingStore={this.props.updatingStore}
                            incident={incident}
                            violations={this.props.violationList}
                            index={index}
                            onChange={this.onIncidentChange}
                            onDelete={this.onIncidentDelete}
                            errors={this.props.errors}
                        />
                    ))
                }

                <div className="btnContainer">
                    <Button
                        className="btnAddViolation"
                        onClick={() => { this.onIncidentAdd() }}
                        disabled={this.props.updatingStore}> <i className="fas fa-plus"></i> Add incident
                    </Button>
                </div>
            </div>
        );
    }
}

export default VialationPart